import Joi from '@hapi/joi'
import { use } from 'react'

export const UserMappingListingSchema = {
    groupID: Joi.number().invalid(0).required().label("Group").messages({
        "any.invalid": `Group required`,
    }),
    estate: Joi.number().invalid(0).required().label("Estate").messages({
        "any.invalid": `Estate required`,
    }),

    user: Joi.number().invalid(0).required().label("User").messages({
        "any.invalid": `User required`,
    }),

      userRole: Joi.number().invalid(0).required().label("UserRole").messages({
        "any.invalid": `User Role required`,
    }),
    

}

export const UserMappingAddEditSchema = {
    groupID: Joi.number().invalid(0).required().label("Group").messages({
        "any.invalid": `Group required`,
    }),
    estate: Joi.number().invalid(0).required().label("Estate").messages({
        "any.invalid": `Estate required`,
    }),

    user: Joi.number().invalid(0).required().label("User").messages({
        "any.invalid": `User required`,
    }),
    userRole: Joi.number().invalid(0).required().label("User Role").messages({
        "any.invalid": `Role required`,
    }),
   allowOperationEntities: Joi.array().min(1).required().messages({
        'array.base': 'At least one Operation Entity must be selected',
        'array.min': 'At least one Operation Entity must be selected',
        'any.required': 'At least one Operation Entity must be selected'
    }),
}

